import React, { memo, useMemo } from "react"
import { Typography, TextField } from "@mui/material"
import { RenderFileUploadBox } from "views/fileCabinet/FileUploadArea"
import { DescriptionStepProps } from "./types"
import helpDrawerHeader from "assets/help-drawer-header-1x.png"
import helpDrawerHeader2x from "assets/help-drawer-header-2x.png"
import { DocumentThumbnail } from "../../views/fileCabinet/DocumentThumbnail"
import { COPY } from "./constants"

const DescriptionStep: React.FC<DescriptionStepProps> = memo(
  ({
    description,
    handleDescriptionChange,
    uploadedFiles,
    setUploadedFiles,
    setFileUploadErrors,
    isDescriptionValid,
  }) => {
    const isPdf = (uploadedFiles?: FileList): boolean => {
      if (!!uploadedFiles?.length && uploadedFiles[0].name?.toLowerCase().endsWith("pdf")) {
        return true
      }
      return false
    }

    const isPDF = isPdf(uploadedFiles)

    const previewImage = useMemo(() => {
      if (!uploadedFiles || uploadedFiles.length === 0) {
        return undefined
      }

      return (
        <DocumentThumbnail
          style={
            isPDF
              ? {
                  minHeight: "400px",
                }
              : undefined
          }
        />
      )
    }, [uploadedFiles, isPDF])

    const fileUploadBox = useMemo(() => {
      return (
        <RenderFileUploadBox
          setErrors={setFileUploadErrors}
          setUploadedFiles={setUploadedFiles}
          uploadedFiles={uploadedFiles}
          previewImage={previewImage}
          hideFileFormats
          color="secondary"
        />
      )
    }, [uploadedFiles, previewImage, setFileUploadErrors, setUploadedFiles])

    return (
      <>
        <img
          srcSet={`${helpDrawerHeader2x} 2x, ${helpDrawerHeader} 1x`}
          src={helpDrawerHeader}
          style={{ maxWidth: "285px" }}
          alt={COPY.DESCRIPTION.IMAGE_ALT}
        />
        <Typography variant="h5" gutterBottom>
          {COPY.DESCRIPTION.TITLE}
        </Typography>

        <Typography variant="body1" gutterBottom>
          {COPY.DESCRIPTION.SUBTITLE}
        </Typography>

        <TextField
          id="help-drawer-description"
          name="description"
          value={description}
          onChange={handleDescriptionChange}
          label={COPY.DESCRIPTION.LABEL}
          multiline
          rows={6}
          fullWidth
          variant="outlined"
          inputProps={{ maxLength: 1500 }}
          error={!isDescriptionValid}
        />

        {fileUploadBox}
      </>
    )
  }
)

export default DescriptionStep
